import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../-LazyRoutePage"

const CriticalStockReportDetailPage = lazy(
  () =>
    import(
      "../../../../components/WMS/Warehouses/CriticalStockReportDetailPage"
    ),
)

export const Route = createFileRoute(
  "/_layout/WMS/warehouses/critical-stock-report/$id",
)({
  component: CriticalStockReportDetailRoute,
})

function CriticalStockReportDetailRoute() {
  return (
    <LazyRoutePage>
      <CriticalStockReportDetailPage />
    </LazyRoutePage>
  )
}
